import { settings } from '../settings.js';

const counter = {};

const setCounter = () => {
    counter.beadNumber = 1;
    counter.row = 1;
    counter.side = 1;

    if (settings.pattern.name === 'star') {
        counter.square = 1;
    }
};

const getCorrectSide = side => {
    if (settings.pattern.name === 'square') return side - 1;

    if (side === 1) {
        return 3;
    } else if (side === 2) {
        return 0;
    } else if (side === 3) {
        return 2;
    } else if (side === 4) {
        return 1;
    }
};

const getNudge = (num, row) => {
    if (row % 2 === 0) {
        const mid = (row + 1) / 2;
        return 2 * Math.abs(mid - num);
    } else {
        return Math.abs((row - 1) - (2 * (num - 1)));
    }
};

const placeBead = ({bead}) => {
    if (settings.pattern.name === 'star') {
        bead.hidden = counter.square !== 1; // start with warped square 1 showing
    }

    if (!bead.star) {
        bead.star = Object.assign({}, counter);
    }

    const angle = (Math.PI * (2/4) * getCorrectSide(counter.side));


    let x1 = 40 + (counter.row - 1) * 24 + getNudge(counter.beadNumber, counter.row) * 8;
    let y1 = ((counter.beadNumber - 1) * 64) - ((counter.row - 1) * 32);

    if (settings.pattern.name === 'star' && [1, 2].some(element => element === bead.star.side)) {
        y1 = -y1;
    }

    bead.x = x1 * Math.cos(angle) - y1 * Math.sin(angle);
    bead.y = y1 * Math.cos(angle) + x1 * Math.sin(angle);

    bead.setAngle(angle * (180 / Math.PI));

    bead.x += 400 + (settings.rows * 21);
    bead.y += 400 + (settings.rows * 21);

    if (settings.pattern.name === 'star' && bead.star.row === settings.rows) {
        if ([1, 3].some(element => element === bead.star.side)) {
            bead.ignore = true;
        }
        if (bead.star.side === 4) {
            if (bead.star.beadNumber === 1) {
                bead.ignore = true;
            }
        }
    }
};

const advanceCounter = ({rowLengths}) => {
    counter.beadNumber++;

    if (counter.beadNumber > rowLengths[counter.row - 1]) {
        counter.beadNumber = 1;
        counter.row++;
    }
    if (counter.row > settings.rows) {
        counter.row = 1;
        counter.side++;
    }
    if (settings.pattern.name === 'star') {
        if (counter.side > 4) {
            counter.side = 1;
            counter.square++;
        }
    }
};

export const addStarAddress = ({bead, i, rowLengths}) => {
    if (i === 0) setCounter();
    bead.star = Object.assign({}, counter);
    advanceCounter({rowLengths});
};

export const applySquare = ({bead, i, rowLengths}) => {
    if (i === 0) setCounter();

    if (settings.pattern.name === 'star' && counter.square > 5) {
        bead.ignore = true;
    }

    if (settings.pattern.name === 'square' && counter.side > 4) {
        bead.ignore = true;
    }

    if (!bead.ignore) {
        placeBead({bead});
    }

    if (bead.ignore) {
        bead.x = -100;
        bead.y = -100;
    }

    advanceCounter({rowLengths});
};
